export function getImageFileInfo(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = (f) => {
      const image = new Image()
      image.onload = () => {
        resolve({
          size: file.size,
          width: image.width,
          height: image.height,
        })
      }
      image.onerror = (e) => {
        reject(new Error(e.message))
      }
      image.src = f.target.result
    }
    reader.onerror = () => {
      reject(new Error(reader.error))
    }
  })
}

export function getVideoFileInfo(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = (f) => {
      const videoEle = document.createElement('video')
      videoEle.style = 'display:none;'
      videoEle.preload = 'metadata'
      videoEle.addEventListener(
        'loadedmetadata',
        () => {
          const data = {
            size: file.size,
            width: videoEle.videoWidth,
            height: videoEle.videoHeight,
          }
          resolve(data)
        },
        false
      )
      videoEle.addEventListener(
        'error',
        () => {
          reject(new Error(videoEle.error.message))
        },
        false
      )
      const sourceEle = document.createElement('source')
      // .mov后缀的视频type为video/quicktime，在浏览器会报媒体类型错误，写死mp4（不知道其他视频类型也固定为mp4会不会有问题）
      sourceEle.type = 'video/mp4'
      sourceEle.addEventListener(
        'error',
        () => {
          reject(new Error('视频信息获取失败'))
        },
        false
      )
      sourceEle.src = f.target.result
      videoEle.appendChild(sourceEle)
    }
    reader.onerror = () => {
      reject(new Error(reader.error))
    }
  })
}
